import { render, staticRenderFns } from "./DraggableListsMobileLayersItem.vue?vue&type=template&id=24a0378e&scoped=true&"
import script from "./DraggableListsMobileLayersItem.vue?vue&type=script&lang=js&"
export * from "./DraggableListsMobileLayersItem.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListsMobileLayersItem.vue?vue&type=style&index=0&id=24a0378e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a0378e",
  null
  
)

export default component.exports